module.exports = __webpack_public_path__ + "img/vade-1024.2af117df.png";